const HBUS_READY_EVENT = 'hbus:ready';

const HBUS_CLIENT_TYPES = {
  HTTP: 'HTTP',
  NAVIGATION: {
    SENDBEACON: 'navigation.sendBeacon',
  },
};

export {
  HBUS_READY_EVENT,
  HBUS_CLIENT_TYPES,
}
